module.exports = __webpack_public_path__ + "static/media/bfile-savings-account.eaf53f11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-savings-account.svg
// module id = 1009
// module chunks = 0